export const NAME = 'credit-file';
